import type { ICatalog } from '@platform/core/types';
import { installedHere } from '../../shell/installedHere';
import type { IRecordTypeFlags } from './IRecordTypeFlags';

/**
 * Ключі типів записів простору, чиє перевизначення «Скинути» змінило б (`overridden` каталогу, ADR-023: не лише власні поля) — лише такий
 * патч може нести власну форму (`forms`), тож «Налаштування › Форми» читають перевизначення тільки цих типів (модулі простору, як у
 * переліку форм). Ключі відсортовано й з'єднано комою — сталий ключ кешу. Чиста функція.
 */
export function overriddenTypeKeys(catalog: ICatalog | undefined): string {
  return (catalog?.modules ?? []).filter(installedHere).flatMap((m) => m.recordTypes)
    .filter((r) => (r as IRecordTypeFlags).overridden).map((r) => r.key).sort().join(',');
}
